import axios from 'axios';

/*
 * int year
 */
export default {
  get(year) {
    return axios.get(`/getPredictionAccuracy?year=${year}`);
  },
};
